module.exports = __webpack_public_path__ + "images/741de9ef1ad16c29ca17be7732b0b6ba.svg";